/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const u=require("react"),c=(a,r)=>{const e=u.useRef(void 0),[i,n]=u.useState(a),s=t=>{e.current=t,n(t)};return e.current=void 0,{get value(){return e.current!==void 0?e.current:r!==void 0?r:i},set value(t){s(t)}}};exports.useImmediateInheritState=c;
